import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Lock } from 'lucide-react';

const ICONS = [MapPin, Clock];

/* Compact reveal "signs" that light up as the party details emerge. */
export const RevealCards = ({ items = [], progress = 0 }) => {
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="reveal-cards">
      {items.map((item, i) => {
        const revealed = progress >= item.at - 0.001;
        const Icon = ICONS[i] || MapPin;
        return (
          <motion.div
            key={i}
            data-testid={`milestone-card-${i + 1}`}
            initial={false}
            animate={revealed ? { opacity: 1, scale: 1 } : { opacity: 0.6, scale: 0.98 }}
            transition={{ type: 'spring', stiffness: 240, damping: 18 }}
            className={`relative rounded-xl p-2.5 overflow-hidden border ${
              revealed
                ? 'bg-[hsl(var(--hazard-yellow))] border-transparent'
                : 'glass-2'
            }`}
          >
            <div className="flex items-start gap-2">
              <span
                className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${
                  revealed ? 'bg-[#0e1217] text-[hsl(var(--hazard-yellow))]' : 'bg-white/10 text-white/40'
                }`}
              >
                {revealed ? <Icon size={15} /> : <Lock size={14} />}
              </span>
              <div className="min-w-0">
                <div className={`font-display tracking-wide text-[10px] leading-none ${revealed ? 'text-[#0e1217]/70' : 'text-white/40'}`}>
                  {item.kicker}
                </div>
                <div className={`text-[12px] font-semibold leading-tight mt-0.5 ${revealed ? 'text-[#0e1217]' : 'text-white/35'}`}>
                  {revealed ? item.label : 'Locked\u2026'}
                </div>
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};
